import { Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { AddCollectorSkeleton } from '@/features/integrations/collectors/components/skeletons'
import { lazyNamed } from '@/utils/lazy-named'

import { ROLES } from '@/shared/auth/constants'
import { roleAuthGuard } from '@/shared/auth/utils/router'

import { ErrorBoundary } from '@/components/common/error-boundary'

/**
 * Loaded on intent, not eagerly (P-21): the wizard is a screen most sessions
 * never open, and it is only ever reached by clicking `Add remote collector` —
 * which preloads the chunk on hover.
 */
const AddCollectorInstallStep = lazyNamed(
	() =>
		import('@/features/integrations/collectors/components/add-collector/install-step'),
	'AddCollectorInstallStep',
)

export const Route = createFileRoute('/_dashboard/integrations/collectors/new')(
	{
		// Same bar as `/integrations/new` and the affordances that link here (D34):
		// installing an agent inside the customer's network is not a smaller act
		// than connecting a cloud connector, and a gate on the button alone leaves
		// the URL open.
		beforeLoad: () => roleAuthGuard(ROLES.SystemManager),

		head: () => ({
			meta: [{ title: 'Add Remote Collector | Integrations | BitLyft AIR®' }],
		}),

		component: AddCollectorPage,
		errorComponent: RouteErrorComponent,
	},
)

function AddCollectorPage() {
	return (
		<ErrorBoundary feature="integrations" section="add-collector">
			<Suspense fallback={<AddCollectorSkeleton />}>
				<AddCollectorInstallStep />
			</Suspense>
		</ErrorBoundary>
	)
}
